import { IS_PRERENDERING } from '@/init/settings.ts'

export function header() {
  if (IS_PRERENDERING) {
    return
  }

  const hamburger = document.querySelector('.public-pdf__mobile-menu-open')
  const navclose = document.querySelector('.public-pdf__mobile-menu-close')
  const navpane = document.querySelector('.public-pdf__mobile-navbar')

  if (hamburger) {
    hamburger.addEventListener('click', toggleMobileMenu)
  }
  if (navclose) {
    navclose.addEventListener('click', toggleMobileMenu)
  }

  function toggleMobileMenu() {
    if (hamburger.classList.contains('active')) {
      hamburger.classList.remove('active')
      navpane.classList.remove('active')
    } else {
      hamburger.classList.add('active')
      navpane.classList.add('active')
    }
  }
}
